import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition){
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  store.dispatch('bootstrap/burger', false);

  next();
})

export default router
